export default __webpack_public_path__ + "static/media/vn.62e026b2.svg";